const icons = {
  dashboard: "/assets/images/icons/dashboard-icon.svg",
  exterminator: "/assets/images/icons/dashboard-icon.svg",
  inventory: "/assets/images/icons/inventory-icon.svg",
  customer: "/assets/images/icons/customer-icon.svg",
  task: "/assets/images/icons/task-manage-icon.svg",
  performance: "/assets/images/icons/performance-icon.svg",
  logout: "/assets/images/icons/logout-icon.svg",
  user: "/assets/images/img/user.png",
  totalUsers: "/assets/images/icons/total-users-icon.png",
  growArrowIcon: "/assets/images/icons/grow-arrow-icon.svg",
  totalTaskIcon: "/assets/images/icons/total-task-icon.png",
  dashCubeIcon: "/assets/images/icons/dash-cube-icon.png",
  notFound: "/assets/images/icon/search-file.gif",
  doubleArrow: "/assets/images/icons/double-arrow.svg",
  calendar: "/assets/images/icons/calendar.png",
  // --
  scout: "/assets/images/icons/scout.svg",
  agronomist: "/assets/images/icons/agronomist-icon.svg",
  crop: "/assets/images/icons/crop.svg",
  growers: "/assets/images/icons/growers.svg",
  product: "/assets/images/icons/product.svg",
  content: "/assets/images/icons/content.svg",
  splash: "/assets/images/icons/splash-icon.png",
  noProfile: "/assets/images/icons/no-profile-picture-15257.svg",
  addPhoto: "/assets/images/icons/add-photo-icon.svg",
  exportCSV: "/assets/images/icons/export-csv-icon.svg",
  dopeIcon: "/assets/images/icons/Polygon 1.svg",
};

const logos = {
  appLogo: "/assets/images/img/logo.png",
};

const backgrounds = {
  loginBackground: "/assets/images/background/login_img.png",
};

const images = {
  graphImage: "/assets/images/img/graph.png",
  inProgress: "/assets/images/img/not-found-2.png",
};

const placeHolders = {};

const ImagesUrl = {
  ...icons,
  ...images,
  ...backgrounds,
  ...logos,
  ...placeHolders,
};

export default ImagesUrl;
